import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Leaf } from "lucide-react";
import { NAV } from "@/constants/testIds";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname, loc.hash, loc.key]);


  return (
    <header
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          setOpen(false);
          event.currentTarget.querySelector("button[aria-controls]")?.focus();
        }
      }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-200 ${
        scrolled
          ? "bg-[#061414]/95 backdrop-blur-xl border-b border-white/10 text-white"
          : "bg-[#061414]/95 text-white"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 xl:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2 group shrink-0">
          <span className="grid place-items-center w-8 h-8 rounded-md text-white" style={{ background: "linear-gradient(135deg, #10B981, #059669)" }}>
            <Leaf size={16} strokeWidth={2.5} />
          </span>
          <div className="font-display font-extrabold tracking-tight text-base sm:text-lg leading-none">
            Bandofotovoltaico<span className="text-emerald-500">24</span>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-6 text-sm whitespace-nowrap">
          <Link to="/analisi-preventivo" data-testid={NAV.linkAnalisi} className="hover:text-emerald-500 transition-colors">Analisi preventivo</Link>
          <Link to="/#come-funziona" data-testid="nav-link-metodo" className="hover:text-emerald-300 transition-colors">Come funziona</Link>
          <Link to="/configuratore" data-testid={NAV.linkConfiguratore} className="hover:text-emerald-500 transition-colors">Configuratore</Link>
          <Link to="/#guide" data-testid={NAV.linkGuide} className="hover:text-emerald-500 transition-colors">Guide PDF</Link>
        </nav>

        <div className="hidden xl:block shrink-0">
          <Link to="/analisi-preventivo" data-testid={NAV.ctaContattaci} className="btn-primary text-xs px-5 py-2.5">
            Analizza il mio preventivo
          </Link>
        </div>

        <button
          data-testid={NAV.mobileToggle}
          className="xl:hidden p-2 shrink-0 min-h-11 min-w-11 focus-visible:outline focus-visible:outline-2 focus-visible:outline-emerald-400"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Chiudi menu" : "Apri menu"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav id="mobile-navigation" aria-label="Navigazione mobile" className="xl:hidden max-h-[calc(100dvh-4rem)] overflow-y-auto bg-[#061414] border-b border-white/10 text-white">
          <div className="px-6 py-4 flex flex-col gap-1 text-sm [&>a]:min-h-11 [&>a]:flex [&>a]:items-center">
            <Link to="/analisi-preventivo">Analisi preventivo</Link>
            <Link to="/#come-funziona">Come funziona</Link>
            <Link to="/configuratore">Configuratore</Link>
            <Link to="/#guide">Guide PDF</Link>
            <Link to="/analisi-preventivo" className="btn-primary text-xs w-fit">Analizza il mio preventivo</Link>
          </div>
        </nav>
      )}
    </header>
  );
}
